import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { Button } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import IndeterminateCheckBoxOutlinedIcon from '@mui/icons-material/IndeterminateCheckBoxOutlined';



export default function Enter(props) {

  const normalSelectStyling = {
    width: '100%',
    backgroundColor: '#3B4E68',
    border: '1px solid #3B4E68',
    color: '#FFFFFF',
    '&:hover': {
      color: '#3B4E68',
      border: '1px solid #3B4E68',
      backgroundColor: '#60A5FA',
    }
  };

  const showSelectStyling = {
    width: '100%',
    // backgroundColor: '#3B4E68',
    backgroundColor: 'red',
    border: '1px solid #3B4E68',
    // color: '#FFFFFF',
    color: '#FFFFFF',
    // '&:hover': {
    //   color: '#3B4E68',
    //   border: '1px solid #3B4E68',
    //   backgroundColor: '#60A5FA',
    // }
  };

  const showIncrementStyling = {
    // color: '#3B4E68',
    color: 'red',
    fontSize: '3rem',
    stroke: "white",
    strokeWidth: "0px",
  };

  const normalIncrementStyling = {
    color: '#3B4E68',
    fontSize: '3rem',
    stroke: "white",
    strokeWidth: "1px",
  };

  const showDecrementStyling = {
    // color: '#3B4E68',
    color: 'red',
    fontSize: '3rem',
    stroke: "white",
    strokeWidth: "0px",
  };

  const normalDecrementStyling = {
    color: '#3B4E68',
    fontSize: '3rem',
    stroke: "white",
    strokeWidth: "1px",
  };

  return (
    <Box sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      margin: '20px',
      marginTop: '5px',
      marginBottom: '20px',
    }}>

      <Box
        sx={{
          width: '15%',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <IconButton
          aria-label="decrement"
          sx={{
            width: '100%',
          }}
          size="large"
          // disabled 
          style={{ backgroundColor: 'transparent' }}
          onClick={props.decrement}
        >
          <IndeterminateCheckBoxOutlinedIcon
            sx={props.showDecrementButton ? showDecrementStyling : normalDecrementStyling}
          // sx={props.showIncrementButton ? showIncrementStyling : normalIncrementStyling}
          // sx={{
          //   color: '#3B4E68',
          //   fontSize: '3rem',
          // }}
          />
        </IconButton>

      </Box>


      <Box
        sx={{
          width: '60%',
        }}
      >

        <Button
          variant="contained"
          sx={props.showSelectButton ? showSelectStyling : normalSelectStyling}
          // sx={{
          //   width: '100%',
          //   backgroundColor: '#3B4E68',
          //   border: '1px solid #3B4E68',
          //   color: '#FFFFFF',
          //   '&:hover': {
          //     color: '#3B4E68',
          //     border: '1px solid #3B4E68',
          //     backgroundColor: '#60A5FA',
          //   }
          // }}
          onClick={props.onTap}
          disabled={props.disable}
        >
          Select
        </Button>
      </Box>

      <Box
        sx={{
          width: '15%',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <IconButton
          aria-label="increment"
          // disabled 
          style={{ backgroundColor: 'transparent' }}
          onClick={props.increment}
        >
          <AddBoxOutlinedIcon
            // sx={props.showDecrementButton ? showDecrementStyling : normalDecrementStyling}
            sx={props.showIncrementButton ? showIncrementStyling : normalIncrementStyling}
          // sx={{
          //   color: '#3B4E68',
          //   fontSize: '3rem',
          // }}
          />
        </IconButton>
      </Box>

    </Box >
  );

}